(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPointToAssistant(
    $timeout, $filter, toastr, $http, $window
  ) {
    return {
      restrict: 'EA',
      scope: {
        origin: '=origin',
        targets: '=targets',
        callback: '&callback'
      },
      templateUrl: 'app/directives/pointToAssistant/pointToAssistant.template.html',
      link: function(scope, element, attrs) {

        scope.canvasElement = null;
        scope.canvasRect = null;
        scope.ctx = null;
        scope.windowWidth = $window.innerWidth;
        let targets = [];

        scope.createCanvasElement = () => {
          scope.canvasElement = document.createElement('canvas');
          scope.canvasElement.id = 'POINT_TO_ASSISTANT';
          scope.canvasElement.classList.add('canvas-overlay');
          element.append(scope.canvasElement);
        }

        scope.init = () => { 
          if (!document.getElementById('POINT_TO_ASSISTANT')) {
            scope.createCanvasElement();
          }
          $timeout(() => { 
            scope.windowWidth = $window.innerWidth;
            scope.canvasRect = scope.canvasElement.getBoundingClientRect();
            scope.initPointAssistant(scope.canvasElement)
            scope.checkInput();
          }, 100);
        }

        scope.initPointAssistant = (canvas) => {
          var dpr = window.devicePixelRatio || 1;
          var rect = canvas.getBoundingClientRect();
          canvas.width  = rect.width * dpr;
          canvas.height = rect.height * dpr;
          scope.ctx = canvas.getContext('2d');
          scope.ctx.scale(dpr, dpr);
        };

        
        function reportWindowSize() {
          scope.init();
          scope.$apply();
        }
        window.onresize = reportWindowSize;        


        scope.checkInput = () => {
          if (scope.origin && scope.targets.length) {
            scope.ctx.clearRect(0, 0, scope.canvasElement.width, scope.canvasElement.height);
            scope.targetElements()
          } else {
            scope.ctx.clearRect(0, 0, scope.canvasElement.width, scope.canvasElement.height);
            targets = [];
          }
        }

        scope.targetElements = () => { 
          targets = [];
          scope.targets.forEach(elementRef => {
            let element = document.getElementById(elementRef)
            if (element) { 
              targets.push({ref: elementRef, rect: element.getBoundingClientRect()})
            }
          });

          if (targets.length > 0) { 
            scope.unMaskTargets();
          }
        }

        scope.unMaskTargets = () => {
          scope.ctx.fillStyle = '#459eec30';
          scope.ctx.fillRect(0, 0, scope.canvasElement.width, scope.canvasElement.height);
          scope.canvasElement.style.pointerEvents = 'auto';
          var labelText = $filter('translate')('PasteVariablesHere');
          $timeout(()=> {

            var textWidth = scope.ctx.measureText(labelText).width;
            targets.forEach((target, index) => {
              scope.ctx.clearRect(
                (target.rect.left - scope.canvasRect.left),
                (target.rect.y - scope.canvasRect.top),
                target.rect.right  - target.rect.left,
                target.rect.bottom - target.rect.top
                );
                
                scope.ctx.strokeStyle = '#459eec';
                scope.ctx.beginPath();
                scope.ctx.rect(
                  (target.rect.left - scope.canvasRect.left),
                  (target.rect.y - scope.canvasRect.top),
                  target.rect.right  - target.rect.left,
                  target.rect.bottom - target.rect.top
                  )
                  scope.ctx.stroke();
                  var offset = 100 * (index + 1);
                  drawLabel(target, labelText, textWidth, offset)
            }, 20)
          })

          scope.canvasElement.addEventListener('click', scope.clickHandler);
        }

        function drawLabel(target, labelText, textWidth, offset) {
          var offsetX = 5;
          var offsetY = 7;
          var startX = (target.rect.right - scope.canvasRect.left) - offset;
          var startY =(target.rect.y - scope.canvasRect.top) + 10;

          
          scope.ctx.shadowBlur = 10;
          scope.ctx.shadowColor = "#00000080";
          scope.ctx.fillStyle = '#459eec';
          scope.ctx.beginPath();
          scope.ctx.moveTo(startX, startY);
          scope.ctx.lineTo(startX + offsetX, startY - offsetY);
          scope.ctx.lineTo(startX - offsetX, startY - offsetY);
          scope.ctx.fill();

          var boxHeight = 35;
          var boxWidth = textWidth * 2;

          var startBoxX = startX - (boxWidth / 2);
          var startBoxY = (startY - offsetY) - boxHeight;

          scope.ctx.fillStyle = '#459eec';
          scope.ctx.beginPath();
          scope.ctx.roundRect(startBoxX, startBoxY + 1, boxWidth, 35, 3);
          scope.ctx.fill();

          scope.ctx.shadowBlur = 0;
          scope.ctx.shadowColor = "#00000000";
          scope.ctx.fillStyle = 'white';
          scope.ctx.font = "100% Lato";
          scope.ctx.textAlign = "center";
          
          scope.ctx.fillText(labelText, startBoxX + (boxWidth / 2), startBoxY + 25);

        }

        scope.clickHandler = (event) => {
          scope.canvasElement.remove()
          scope.callback();
        }

        scope.$on('$destroy', function() {
          if (scope.canvasElement) {
            scope.canvasElement.removeEventListener('click', scope.clickHandler);
            scope.canvasElement.remove();
          }
          window.onresize = null;
        });


        scope.init();




      }
    };
  }

  pxPointToAssistant.$inject = ['$timeout', '$filter', 'toastr', '$http', '$window'];

  angular
    .module('printix-admin')
    .directive('pxPointToAssistant', pxPointToAssistant);

})();
